<template>
    <div>
    <nav class="navbar navbar-expand-lg navbar-dark bg-blue">
    <div class="container-fluid px-xl-5 px-lg-3 py-3 py-lg-4">
      <a class="navbar-brand" :href="getUrl('homeUrl')"><img class="nav-logo" src="~__STATIC__/svg/valle.svg" alt="logo"></a>
      <a class="navbar-brand" :href="getUrl('homeUrl')"><img class="nav-logo" src="~__STATIC__/svg/valle-plus.svg" alt="logo"></a>
      <a class="nav-link order-lg-5 text-white position-relative" href="#" @click="toggle" v-if="showCart">
        <img class="cart-icon" src="~__STATIC__/svg/cart.svg" alt="logo">
        <span class="header--cart--counter">{{ count }}</span>
<!--        <img class="nav-logo-cart" src="~__STATIC__/img/cart.png" alt="logo">-->
        <span class="d-none d-lg-inline ml-2">Carrito de compras</span>
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarMain"
              aria-controls="navbarMain" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse mt-3 pt-3 mt-lg-0 pt-lg-0" id="navbarMain">
        <ul class="navbar-nav ml-auto flex-lg-row-reverse">
          <li class="nav-item px-xl-3 text-lg-center align-self-lg-center">
            <a class="nav-link text-white" aria-current="page" :href="getUrl('userDashboardUrl')">
              <img class="mr-1 h-30px d-none d-lg-inline" src="~__STATIC__/svg/login.svg" alt="Login">
              Ingresa
              <img class="ml-2 h-30px d-lg-none" src="~__STATIC__/svg/login.svg" alt="Login">
            </a>
          </li>
          <li class="nav-item px-xl-3 text-lg-center align-self-lg-center">
            <a class="nav-link text-white" :href="getUrl('vbUrl')">
              <img class="mr-1 h-30px d-none d-lg-inline" src="~__STATIC__/img/card_white.png" alt="Recarga">
              Recarga cuponera
              <img class="ml-2 h-30px d-lg-none" src="~__STATIC__/img/card_white.png" alt="Recarga">
            </a>
          </li>
          <li class="nav-item px-xl-3 text-lg-center align-self-lg-center">
            <a class="nav-link text-white" :href="getUrl('cardDataUrl')" v-text="getTranslation('cardDataLabel')"></a>
          </li>
          <li class="nav-item px-xl-3 text-lg-center align-self-lg-center">
            <a class="nav-link text-white" :href="getUrl('faqUrl')" v-text="getTranslation('faqLabel')"></a>
          </li>
<!--          <li class="nav-item px-xl-3 text-lg-center align-self-lg-center">
            <a class="nav-link text-white" :href="getUrl('healthUrl')" v-text="getTranslation('healthLabel')"></a>
          </li>-->
        </ul>
      </div>
    </div>
  </nav>
</div>

</template>

<script>
    import * as Actions from '../store/action-types';
    import cartMixin from '../mixins/cartMixin';
    import siteConfig from '../mixins/siteConfig';

    export default {
        props: {
            showCart: {
                type: Boolean,
                default() {
                    return true;
                }
            },
            promo: {
                type: Boolean,
                default() {
                    return true;
                }
            }
        },

        mixins: [cartMixin, siteConfig],

        computed: {
            user() {
                return window.Valle.user && window.Valle.user.name
                    ? window.Valle.user.name.split(' ')[0]
                    : undefined;
            },

            welcomeMessage() {
                return `${this.getTranslation('helloLabel')}, ${this.user}`;
            }
        },

        methods: {
            toggle() {
                this.$store.dispatch(Actions.toggleFooter);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue